<template>
    <b-tabs @input="onClick" :position="data.Position || 'is-centered'" class="block">
        <template v-for="(tab, n) in data.Data">
            <b-tab-item :key="n" :value="n.toString()" :label="tab.Name"></b-tab-item>
        </template>
    </b-tabs>
</template>
<script>
export default {
    props: {
        data: {
            type: Object
        }
    },
    methods: {
        onClick (e) {
            var temp = {
                Type: 'tab'
            }
            this.mainAction(temp, parseInt(e))
            console.log(this.$tabs)
        }
    }
}
</script>
